export const BUTTON_COLORS = {
  default: "default",
  primary: "primary",
  success: "success",
  warning: "warning",
  accent: "accent",
  link: "link",
};
